import { logOperationalEvent } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

const reportedAdvertIds = new Set<string>();

export const resetReportedAdvertIdsForTests = () => reportedAdvertIds.clear();

export const reportMissingDsaLegalNameOnce = (advertId: string) => {
  if (reportedAdvertIds.has(advertId)) return;
  reportedAdvertIds.add(advertId);
  logOperationalEvent({ eventName: 'Sponsored_DSA_Legal_Name_Divergence', advertId });
};
